import registerPromiseWorker from 'promise-worker/register';
import { recommendedMatchScore } from '../../generic/recommendedMatchScore/recommendedMatchScore';
import { workerFactory } from '../../generic/workerFactory';
import { extraProfileData2Object } from '../misc/extraProfileData2Object/extraProfileData2Object';

/**
 * Registers the participants match worker.
 *
 * @return {undefined} No return value.
 */
export function registerParticipantsMatchWorker() {
    registerPromiseWorker(matchParticipants);
}

/**
 * Creates a factory function that returns a memoized function for matching participants in a web worker or the main thread.
 *
 * @param {string} workerURL - The URL of the web worker script.
 * @return {function} - A memoized function that matches participants in a web worker or the main thread.
 */
export function participantsMatcherWorkerFactory(workerURL) {
    return workerFactory(workerURL, matchParticipants);
}

/**
 * Generates an array of objects containing the fitness score and participant details for each participant in the given array.
 *
 * @param {Object} options - The options object.
 * @param {Array} options.participants - The array of participant objects.
 * @param {Object} options.filterParams - The filter parameters object.
 * @param {Object} options.filterParams.categories - The categories object used for fitness calculation.
 * @return {Array} An array of objects containing the fitness score and participant details.
 */
function matchParticipants({participants, filterParams}) {
    return participants.map(p => ({
        fitness: recommendedMatchScore(filterParams.categories, extraProfileData2Object(p.extra_profile_data)),
        participant: p,
    }));
}
